import { BaseAccomodation } from "@models/base-accomodation.model";
import { BaseConverter } from "./base.converter";
import { BaseAccomodationDto } from "@dtos/base-accomodation.dto";
import { LocationConverter } from "./location.converter";
import { ContactConverter } from "./contact.converter";

export class BaseAccomodationConverter extends BaseConverter<BaseAccomodation, BaseAccomodationDto> {
    private locationConverter = new LocationConverter();
    private contactConverter = new ContactConverter();

    modelToDto(model: BaseAccomodation): BaseAccomodationDto {
            return new BaseAccomodationDto(
                model.name,
                model.contactDto ? this.contactConverter.modelToDto(model.contactDto) : undefined,
                model.locationDto ? this.locationConverter.modelToDto(model.locationDto) : undefined
            );
    }
    
    dtoToModel(dto: BaseAccomodationDto): BaseAccomodation {
        return new BaseAccomodation(
            dto.name,
            dto.contactDto ? this.contactConverter.dtoToModel(dto.contactDto) : undefined,
            dto.locationDto ? this.locationConverter.dtoToModel(dto.locationDto) : undefined
        );
    }

}